module.exports = __webpack_public_path__ + "assets/add-on-illustrations-adapter-01.08ae9f29.svg";